import { FC, SVGAttributes } from 'react';

const MemberSolid: FC<React.PropsWithChildren<React.PropsWithChildren<SVGAttributes<SVGElement>>>> = ({ ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" shapeRendering="geometricPrecision" {...props}>
      <path
        d="M7.67188 6.99961C7.67188 4.35954 9.37179 2.09961 12.0004 2.09961C14.6291 2.09961 16.329 4.35954 16.329 6.99961C16.329 9.63968 14.6291 11.8996 12.0004 11.8996C9.37179 11.8996 7.67188 9.63968 7.67188 6.99961Z"
        fill="currentColor"
      />
      <path
        d="M3.30134 18.9092C4.16198 15.925 7.66088 13.0996 11.9995 13.0996C16.3382 13.0996 19.837 15.925 20.6977 18.9092C20.8789 19.5374 20.6925 20.137 20.3149 20.5537C19.95 20.9564 19.4164 21.1853 18.8585 21.1853H5.14054C4.58259 21.1853 4.04902 20.9564 3.68413 20.5537C3.3065 20.137 3.12016 19.5374 3.30134 18.9092Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default MemberSolid;
